import React, { useContext } from 'react'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import actionSpin from 'images/icon-loop.svg'
import { getDataForSpinModal } from 'services/spin'
import AwesomeDebouncePromise from 'awesome-debounce-promise'

const DailySpin = () => {
  const modal_context = useContext(modalContext)
  const { toggleModal, setModalContent, setSlotsOverlay, showSignInModalTab } =
    modal_context || {}
  const openSpinModal = async () => {
    try {
      let response = await getDataForSpinModal()
      setModalContent({
        type: 'spin',
        title: 'Daily Spin',
        lastWinner: response.lastWinner,
        lastWinDate: response.lastWinDate,
        spinsRemaining: response.spinsRemaining,
        totalSpinsToday: response.totalSpinsToday,
      })
      setSlotsOverlay(true)
      toggleModal('on')
    } catch (e) {
      console.log(e)
      if (e.message === '401') {
        //If you're not logged in
        showSignInModalTab()
      }
    }
  }
  const debounceSpinModal = AwesomeDebouncePromise(openSpinModal, 500)

  return (
    <span className="action__text spin" onClick={debounceSpinModal}>
      Spin
      <img src={actionSpin} alt="Spin to win" className="icn" />
    </span>
  )
}

export default DailySpin
